var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompGrad({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#F2F5F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 19.3333L8 17L20 10L32 17V25.5H30V18.1667L28 19.3333V26.0113L27.7774 26.2864C25.9457 28.5499 23.1418 30 20 30C16.8582 30 14.0543 28.5499 12.2226 26.2864L12 26.0113V19.3333ZM14 20.5V25.2917C15.4672 26.954 17.6111 28 20 28C22.3889 28 24.5328 26.954 26 25.2917V20.5L20 24L14 20.5ZM11.9693 17L20 21.6846L28.0307 17L20 12.3154L11.9693 17Z",
    fill: "#4778F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompGrad);
export default __webpack_public_path__ + "static/media/compGrad.ce4f0a484086b92e68d71536c1ba67bb.svg";
export { ForwardRef as ReactComponent };